export default{
  label:'padding-left',
  isResponsive:true,
  prefix:'pl',
  isStepAsLabel:true,
  steps:['0','1','2','3','4','5']
}


// WEBPACK FOOTER //
// ./src/shell/schemas/general/padding/padding-l.js